export type VolumeSlide = {
  src: string
  title: string
  caption: string
}

export const volumeThreeSlides: VolumeSlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/sPDPvUzWABj8Kd2md6xdeP/slide-1-portada.png',
    title: 'Cover',
    caption: 'Three levels for every resident: FEEL, HELP, DO.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/q15iUYYvqGVpD8X358m1RF/slide-2-escalera-tres-niveles.png',
    title: 'The Warm Ladder',
    caption: 'One activity, three versions, run at the same time. No one left out.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7YZPVhxUS7dCfeEKfBm18B/slide-3-sesion-tres-vias.png',
    title: 'The Three-Way Session',
    caption: 'Sessions of 15, 30 or 45 minutes, minute by minute.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8W7Ka2BSFBDjHAg9CBWjyT/slide-4-actividad-cheesecake.png',
    title: 'Sample activity: Yogurt Cheesecake Cups',
    caption: '15 ready-to-run activities, with safety built in.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pJJJG8W54ernU75Gd8CrL7/slide-5-estacion-semillas.png',
    title: 'Sample activity: Seed Packet Station',
    caption: 'Purposeful kitchen and garden tasks.',
  },
]
